export const labelsColors = {
  GREEN: "#61bd4f",
  YELLOW: "#f2d600",
  ORANGE: "#ff9f1a",
  RED: "#eb5a46",
  PURPLE: "#c377e0",
  BLUE: "#0079bf",
  SKY: "#00c2e0",
  LIME: "#51e898",
  PINK: "#ff78cb",
  BLACK: "#344563",
  GREY: "#b3bac5",
};

type color =
  | "GREEN"
  | "YELLOW"
  | "ORANGE"
  | "RED"
  | "PURPLE"
  | "BLUE"
  | "SKY"
  | "LIME"
  | "PINK"
  | "BLACK"
  | "GREY";

export interface ILabel {
  id?: number;
  name: string;
  color: color;
}
